import React from 'react';
import { Form, Row, Col } from 'antd';
import { useQuery } from 'react-query';
import { FormBaseSelect } from '../../ui/molecules/FormBaseSelect';
import { FormVariableInputList } from '../../ui/molecules/FormVariableInputList';

import {
  getBIEFullReport,
  getBIEProductiontypes,
  getBIESources,
  getBIEVariables,
} from '../../api/BeerIndustryEmissions';

import { IBIEFormValues, IMethodologyModule } from './interfaces';

import { getFormResult } from '../../utils/getFormResult';
import { generateReportingVariablesArray } from '../../utils';

export const BeerIndustryEmissions: React.FC<IMethodologyModule> = ({
  children,
  marginBetween,
}: IMethodologyModule) => {
  const [form] = Form.useForm();

  const productionTypes = useQuery('BIEProductionTypes', getBIEProductiontypes);
  const sources = useQuery('BIESources', () => getBIESources(form.getFieldValue('production_type')));
  const variables = useQuery('BIEVariables', getBIEVariables);

  const onFinish = (values: IBIEFormValues) => {
    const { production_type, source } = values;

    if (variables.data) {
      getFormResult(getBIEFullReport, {
        productionTypeId: production_type,
        sourceId: source,
        variables: generateReportingVariablesArray(variables.data, form),
      });
    }
  };

  const onChangeProductionType = () => {
    sources.refetch();
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <Row>
        <Col span={11} style={{ marginRight: marginBetween }}>
          <FormBaseSelect
            data={productionTypes.data ? productionTypes.data : []}
            name="production_type"
            cyPrefix="BIE"
            label="Наименование производства"
            defaultValue={1}
            onChange={onChangeProductionType}
          />
          <FormBaseSelect
            data={sources.data ? sources.data : []}
            name="source"
            cyPrefix="BIE"
            label="Наименование источника выделения"
            defaultValue={1}
          />
        </Col>
        <Col>
          <FormVariableInputList
            data={variables.data ? variables.data : []}
            cyPrefix="BIE"
            placeholder="0"
            minValue={0}
            defaultValue={0}
          />
        </Col>
      </Row>
      {children}
    </Form>
  );
};
